module.exports = __webpack_public_path__ + "img/xsh.f8b57a60.jpg";